import type { Application, StarredFilter } from '@/types';

export function isApplicationStarred(app: Application, userId: string | undefined): boolean {
  if (!userId) return false;
  return app.starredBy?.includes(userId) ?? false;
}

export function applicationHasVisibleNotes(app: Application): boolean {
  return app.hasPublicNotes === true;
}

export function matchesStarredFilter(
  app: Application,
  filter: StarredFilter,
  userId: string | undefined,
): boolean {
  if (filter === 'all') return true;
  const starred = isApplicationStarred(app, userId);
  return filter === 'starred' ? starred : !starred;
}

/** Sort key: starred first (0) when ascending. */
export function getApplicationStarSortValue(
  app: Application,
  userId: string | undefined,
): number {
  return isApplicationStarred(app, userId) ? 0 : 1;
}
